module.exports = __webpack_public_path__ + "img/home.f719a1a9.svg";